import {
  RETRIEVE_USERS,
  RETRIEVE_SINGALE_USER,
  UPDATE_USER,
  UPDATE_USER_STATUS,
  RESTORE_USER,
  DELETE_USER,
  CREATE_USER,
  ADD_USER_SUPERADMIN,
  RETRIEVE_USERS_Ad,
  RETRIEVE_REPORTED_USERS,
  ONLINEUSERS,
  ONLINEUSERSOBJ,
  NOONLINEUSERSOBJ,
  FETCH_KYC_LIST,
  FETCH_KYC_LIST_SUCCESS,
  FETCH_KYC_LIST_FAILURE,
  FETCH_USER_KYC_DETAILS,
  FETCH_USER_KYC_DETAILS_SUCCESS,
  FETCH_USER_KYC_DETAILS_FAILURE,
  UPDATE_MODULE,
} from "../actions/types";

const initialState = {
  users: [],
  totalUserCount: 0,
  totalActiveUsers: 0,
  activeList: [],
  activeListCount: 0,
  reportedUsers: [],
  reportedUsersCount: 0,
  onlineUsers: 0,
  onlineUserObj: {},
  loadingKycData: false,
  errorKycData: null,
  kycData: null,
  loadingKycDetails: false,
  errorKycDetails: null,
  kycDetails: null,
  refreshModule: {
    moduleName: "",
    action: "",
    userId: null,
    uuid: "",
  },
};

const userReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RETRIEVE_USERS:
      return {
        ...state,
        users: payload.rows,
        totalUserCount: payload.count,
        totalActiveUsers: payload.totalActiveUsers,
      };

    case RETRIEVE_REPORTED_USERS:
      return {
        ...state,
        reportedUsers: payload.rows,
        reportedUsersCount: payload.count,
      };

    case RETRIEVE_USERS_Ad:
      return {
        activeList: payload.rows,
        activeListCount: payload.count,
      };

    case RETRIEVE_SINGALE_USER:
      return payload;

    case CREATE_USER:
      return payload;

    case UPDATE_USER:
      return payload;

    case UPDATE_USER_STATUS:
      return {
        users: payload,
        totalUserCount: state.totalUserCount,
      };

    case DELETE_USER:
      return {
        ...state,
        users: payload,
        totalUserCount: state.totalUserCount,
      };

    case RESTORE_USER:
      return {
        users: payload,
        totalUserCount: state.totalUserCount,
      };

    case ADD_USER_SUPERADMIN:
      return {
        ...state,
      };

    case ONLINEUSERS:
      return {
        ...state,
        onlineUsers: payload,
      };
    case ONLINEUSERSOBJ:
      return {
        ...state,
        onlineUserObj: payload,
      };
    case NOONLINEUSERSOBJ:
      return {
        ...state,
        users: [],
      };
    case FETCH_KYC_LIST:
      return {
        ...state,
        loadingKycData: true,
        error: null,
      };
    case FETCH_KYC_LIST_SUCCESS:
      return {
        ...state,
        loadingKycData: false,
        kycData: action.payload,
      };
    case FETCH_KYC_LIST_FAILURE:
      return {
        ...state,
        loadingKycData: false,
        error: action.payload,
      };

    case FETCH_USER_KYC_DETAILS:
      return {
        ...state,
        loadingKycDetails: true,
        error: null,
      };
    case FETCH_USER_KYC_DETAILS_SUCCESS:
      return {
        ...state,
        loadingKycDetails: false,
        kycDetails: action.payload,
      };
    case FETCH_USER_KYC_DETAILS_FAILURE:
      return {
        ...state,
        loadingKycDetails: false,
        errorKycDetails: action.payload,
      };
    case UPDATE_MODULE:
      return {
        ...state,
        refreshModule: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
